// packages import
import { Box, Button, CircularProgress, DialogActions, Typography } from '@mui/material'
import { FC, useContext } from 'react'
// component import
import { Alert } from '../../common/Alert'
import { CustomModal } from '../../common/CustomModal'
/// others
import { useArchiveCaseMutation } from '../../../../generated'
import { CANCEL, NOT_APPLICABLE, SOMETHING_WENT_WRONG } from '../../../constants'
import { AppContext, CaseContext } from '../../../context'
import { ActionType } from '../../../context/AppContextReducer'
import { CompleteCaseProps } from '../../../interfaceTypes'
import { capitalizeCase } from '../../../utils'
import { CaseActionType } from '../caseReducer'

export const ArchiveCase: FC<CompleteCaseProps> = ({ refetch }) => {
  const { isEdit, dispatch } = useContext(AppContext)
  const { currentCase, dispatch: caseDispatch } = useContext(CaseContext)
  const { title, id: currentCaseId, caseNumber, court } = currentCase || {}
  const { name: courtName } = court || {}

  const [archiveCase, { loading }] = useArchiveCaseMutation({
    variables: undefined,

    onError() {
      Alert.error(SOMETHING_WENT_WRONG)
    },

    onCompleted(data) {
      if (data) {
        const { archiveCase } = data

        if (archiveCase) {
          const { response } = archiveCase
          const { status } = response || {}

          if (status === 200) {
            Alert.success('Case archived')
            caseDispatch && caseDispatch({ type: CaseActionType.SET_CURRENT_CASE, currentCase: null })
            dispatch({ type: ActionType.SET_IS_EDIT, isEdit: false })
            refetch && refetch()
          }
        }
      }
    }
  })

  const handleClose = () => dispatch({ type: ActionType.SET_IS_EDIT, isEdit: false })

  const handleDelete = async () => {
    await archiveCase({
      variables: {
        archiveCase: {
          id: currentCaseId || ''
        }
      }
    })
  }

  return (
    <CustomModal title="Archive Matter" isOpen={isEdit} handleClose={handleClose}>
      <Typography variant="body1">You are about to archive the following matter:</Typography>
      <Box mt={1}>
        <Typography variant="body1">
          <Typography component="span" fontWeight={500}>
            Title:{' '}
          </Typography>{' '}
          {title || ''}
        </Typography>

        <Typography variant="body1">
          <Typography component="span" fontWeight={500}>
            Matter Number:{' '}
          </Typography>
          {caseNumber || NOT_APPLICABLE}
        </Typography>

        <Typography variant="body1">
          <Typography component="span" fontWeight={500}>
            Court Name:{' '}
          </Typography>
          {capitalizeCase(courtName?.toLowerCase() || '') || ''}
        </Typography>
      </Box>

      <DialogActions sx={{ padding: '30px 0 0', flexWrap: 'wrap' }}>
        <Button onClick={handleClose} variant="outlined" aria-label={CANCEL}>
          {CANCEL}
        </Button>

        <Button
          disabled={loading}
          onClick={handleDelete}
          color="primary"
          variant="contained"
          endIcon={loading && <CircularProgress size={20} color="inherit" />}
          aria-label="archive case"
        >
          Archive Matter
        </Button>
      </DialogActions>
    </CustomModal>
  )
}
